import {Injectable} from '@angular/core';
import {MediaDevicesAbstraction} from './media-devices.abstraction';

@Injectable({
  providedIn: 'root'
})
export class BrowserMediaDevicesService implements MediaDevicesAbstraction {
  async getUserMedia(constraints?: MediaStreamConstraints): Promise<MediaStream> {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new DOMException('getUserMedia não é suportado por este navegador.', 'NotSupportedError'); // String em português
    }
    return navigator.mediaDevices.getUserMedia(constraints);
  }

  async queryPermission(permissionName: PermissionName): Promise<PermissionStatus> {
    if (!navigator.permissions || !navigator.permissions.query) {
      throw new DOMException('API de Permissões não é suportada por este navegador.', 'NotSupportedError'); // String em português
    }
    return navigator.permissions.query({name: permissionName});
  }
}
